import React from 'react';

interface TrimmerDragAreaProps {
    leftPosition: number;
    rightPosition: number;
    onMouseDown: (e: React.MouseEvent) => void;
}

export function TrimmerDragArea({
    leftPosition,
    rightPosition,
    onMouseDown,
}: TrimmerDragAreaProps) {
    return (
        <div
            className="absolute top-0 bottom-0 cursor-grab active:cursor-grabbing z-[5]"
            style={{
                left: `${leftPosition + 16}px`,
                width: `${Math.max(0, rightPosition - leftPosition - 32)}px`,
            }}
            onMouseDown={onMouseDown}
        />
    );
}
